<template>

  <ob-dialog :heading="$t('map.element.properties')" @ok="ok()" @cancel="close()">
    <asset-autocomplete v-model="values.assetId" :label="$t('map.sidebar.link-to-asset')"></asset-autocomplete>
  </ob-dialog>

</template>

<script>

import AssetAutocomplete from '../../assets/asset-autocomplete.vue'
import ObDialog from '../../shared/components/dialog'

export default {
  name: 'element-dialog',

  props: [ 'element' ],

  data () {
    return {
      values: {}
    }
  },

  computed: {

  },

  methods: {
    ok () {
      Object.assign(this.element, this.values)
      this.$emit('submit', this.element)
    },

    close () {
      this.$emit('submit', false)
    }
  },

  mounted () {
    this.values = Object.assign({}, this.element)
  },

  components: {
    ObDialog,
    AssetAutocomplete
  }
}

</script>

<style lang="scss" scoped>

</style>
